import {
  inventoryItemIdFormat,
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const getStorageLocationsForTransfer = {
  name: "getStorageLocationsForTransfer" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema.optional(),
  }),
  output: z.object({
    bins: z.array(
      z.object({
        storageLocationId: storageLocationIdFormat.schema,
        binName: z.string(),
        binType: z.string(),
        productQuantity: z.number().optional(),
        inventoryItemId: inventoryItemIdFormat.schema.nullish(),
        class: z.string().nullish(),
        lotNumber: z.string().nullish(),
        expirationDate: z.string().nullish(),
      }),
    ),
  }),
};
